import {apiService} from "../api.service";
import {SearchedUser, SystemUserAccess, SystemUserWithAttributes} from "../../models/user/user";
import {AuthModel} from "../../models/auth/auth";

export class UserService {
    async getCurrentUserWithAttributes(): Promise<SystemUserWithAttributes> {
        return (await apiService.get<SystemUserWithAttributes>('loggedin')).data;
    }

    async getAccesses(server: string): Promise<SystemUserAccess[]> {
        return (await apiService.get<SystemUserAccess[]>('https://' + server + '/api/v3/accesses', {skipUnauthorizedHandler: true})).data;
    }

    async searchUser(value: string, accountType?: string): Promise<SearchedUser[]> {
        return (await apiService.get<SearchedUser[]>(
            "users/search" + (accountType ? "/" + accountType : ""),
            {
                params: {
                    value
                }
            }
        )).data
    }

    async switchUser(value: string): Promise<AuthModel> {
        return (await apiService.post<AuthModel>("authentication/switch-user?username=" + value)).data;
    }

    async resetUser(): Promise<AuthModel> {
        return (await apiService.delete<AuthModel>("authentication/switch-user")).data;
    }
}

export const userService = new UserService();
